<template>
  <div class="fill-height">
    <FufuHeader :shop="shop"> {{ firstVisitor ? '初回' : '' }}予約 </FufuHeader>

    <v-container class="white" fill-height fluid>
      <v-layout column>
        <v-layout justify-center class="body-1 fufugrey2--text">
          <span v-if="menu"> {{ menu.displayName || menu.name }} </span>
          <span v-if="menu && menu.color">
            &nbsp; / {{ menu.color.displayName }}
          </span>
          <span v-if="menuOption">
            &nbsp; / {{ menuOption.displayName || menuOption.name }}
          </span>
          <span v-if="scalpCare">
            &nbsp; / {{ scalpCare.displayName || scalpCare.name }}
          </span>
        </v-layout>
        <v-layout>
          <v-flex xs4>
            <v-btn
              :to="{
                name: 'ScalpCareSelection',
                params: { shopId, menuId },
                query: {
                  first: firstVisitor,
                  menuOption: menuOption ? menuOption.id : null,
                },
              }"
              text
              exact
              replace
              color="primary"
            >
              <v-icon>mdi-chevron-right</v-icon>
              前の画面へ戻る
            </v-btn>
          </v-flex>
          <v-flex xs4 class="text-center"> 日付を選択してください。 </v-flex>
          <v-flex xs4 class="text-end">
            <v-btn text color="primary" @click="dialog = true">
              カレンダーから日にちを選ぶ
            </v-btn>
          </v-flex>
        </v-layout>

        <v-layout fill-height>
          <v-flex style="max-width: 64px" align-self-center>
            <v-btn :disabled="disabledPrevDates" icon large @click="prevDates">
              <v-icon>mdi-chevron-left</v-icon>
            </v-btn>
          </v-flex>
          <v-flex>
            <v-layout justify-center fill-height>
              <v-flex v-for="d in dates" :key="d" style="max-width: 20%">
                <v-layout fill-height>
                  <ReservableTimeList
                    v-model="datetime"
                    :shop-id="shopId"
                    :menu-id="menuId"
                    :date="d"
                  />
                </v-layout>
              </v-flex>
            </v-layout>
          </v-flex>
          <v-flex style="max-width: 64px" align-self-center>
            <v-btn icon large @click="nextDates">
              <v-icon>mdi-chevron-right</v-icon>
            </v-btn>
          </v-flex>
        </v-layout>

        <v-dialog v-model="dialog">
          <v-card>
            <v-layout>
              <v-spacer />
              <v-btn icon color="primary" @click="dialog = false">
                <v-icon>mdi-close-circle</v-icon>
              </v-btn>
            </v-layout>
            <v-layout>
              <v-flex class="text-center">日にち選択してください。</v-flex>
            </v-layout>
            <v-date-picker
              :value="date"
              :min="minDate"
              :day-format="dayFormat"
              locale="ja-jp"
              full-width
              @input="changeDate"
            />
          </v-card>
        </v-dialog>
        <v-layout>
          <v-flex xs4 offset-xs4 class="pt-5">
            <v-btn
              :disabled="!datetime"
              color="fufuyellow"
              text-color="fufugrey2"
              large
              block
              @click="goNext"
            >
              <span class="subtitle-1">
                <b>次へ</b>
              </span>
            </v-btn>
          </v-flex>
        </v-layout>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import moment from 'moment'
import FufuHeader from '@/components/FufuHeader'
import ReservableTimeList from '@/components/ReservableTimeList'
import { api } from '@/api'

function fetchData(shopId, menuId, menuOptId, scalpCareId) {
  const reqs = [
    api.shops(shopId).get(),
    api
      .shops(shopId)
      .menus(menuId)
      .get(),
    menuOptId &&
      api
        .shops(shopId)
        .menuOptions(menuOptId)
        .get(),
    scalpCareId &&
      api
        .shops(shopId)
        .scalpCares(scalpCareId)
        .get(),
  ]

  return Promise.all(reqs)
}

export default {
  name: 'TimeSelection',
  inject: ['$error'],
  components: {
    ReservableTimeList,
    FufuHeader,
  },
  props: {
    shopId: {
      type: String,
      default: '',
    },
    menuId: {
      type: [String, Number],
      default: '',
    },
    date: {
      type: String,
      default: '',
    },

    firstVisitor: {
      type: Boolean,
      default: false,
    },
    mode: {
      type: Number,
      default: 1,
    },
  },
  data: () => ({
    shop: null,
    menu: null,
    menuOption: null,
    scalpCare: null,

    dialog: false,
    datetime: null,
  }),
  computed: {
    minDate() {
      return moment().format('YYYY-MM-DD')
    },
    dates() {
      let start = moment(this.date).add(-2, 'days')
      let rval = []
      for (let n = 0; n < 5; ++n) {
        rval.push(start.format('YYYY-MM-DD'))
        start.add(1, 'days')
      }
      return rval
    },
    disabledPrevDates() {
      let left = moment(this.date).add(-2, 'days')
      return left.isBefore(moment())
    },
  },
  created() {
    if (!this.shopId || !this.menuId || !this.date)
      this.$error({ status: 404, message: 'Not Found' })
  },
  methods: {
    changeDate(date) {
      this.dialog = false
      // console.log(date)
      this.$router.replace({
        name: 'TimeSelection',
        params: { date },
        query: this.$route.query,
      })
    },
    dayFormat(date) {
      return moment(date).format('D')
    },
    nextDates() {
      let date = moment(this.date)
        .add(5, 'days')
        .format('YYYY-MM-DD')
      this.changeDate(date)
    },
    prevDates() {
      let date = moment(this.date)
        .add(-5, 'days')
        .format('YYYY-MM-DD')
      this.changeDate(date)
    },
    goNext() {
      let [date, time] = this.datetime.split(' ')
      this.$router.replace({
        name: 'CustomerInput',
        params: { date, time },
        query: this.$route.query,
      })
    },
  },

  async beforeRouteEnter(to, from, next) {
    const shopId = to.params.shopId
    const menuId = to.params.menuId
    const menuOptId = to.query.menuOption
    const scalpCareId = to.query.scalpCare
    // console.log(shopId, menuId, menuOptId)
    try {
      const [shop, menu, menuOption, scalpCare] = await fetchData(
        shopId,
        menuId,
        menuOptId,
        scalpCareId
      )
      next(vm => {
        vm.shop = shop
        vm.menu = menu
        vm.menuOption = menuOption
        vm.scalpCare = scalpCare
      })
    } catch (err) {
      next(err)
    }
  },
  async beforeRouteUpdate(to, from, next) {
    const shopId = to.params.shopId
    const menuId = to.params.menuId
    const menuOptId = to.query.menuOption
    const scalpCareId = to.query.scalpCare
    // console.log(shopId, menuId, menuOptId)
    try {
      const [shop, menu, menuOption, scalpCare] = await fetchData(
        shopId,
        menuId,
        menuOptId,
        scalpCareId
      )
      next(vm => {
        vm.shop = shop
        vm.menu = menu
        vm.menuOption = menuOption
        vm.scalpCare = scalpCare
      })
    } catch (err) {
      next(err)
    }
  },
}
</script>

<style></style>
